// src/contexts/LoginModalContext.js
// Provee un modal compartido para pedir login/registrarse desde cualquier parte de la app.
// Exporta LoginModalProvider y hook useLoginModal().

import React, { createContext, useContext, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { buildLoginState, getSafeAuthRedirectPath } from "../auth/authNavigation";

const LoginModalContext = createContext(null);

export function LoginModalProvider({ children }) {
  const navigate = useNavigate();
  const [state, setState] = useState({ open: false, from: "/" });

  const openLogin = useCallback((from = "/") => {
    setState({ open: true, from: getSafeAuthRedirectPath(from, "/") });
  }, []);

  const closeLogin = useCallback(() => {
    setState(s => ({ ...s, open: false }));
  }, []);

  const goToLogin = useCallback(() => {
    const from = getSafeAuthRedirectPath(state.from, "/");
    setState(s => ({ ...s, open: false }));
    navigate("/login", { state: buildLoginState(from), replace: false });
  }, [navigate, state.from]);

  return (
    <LoginModalContext.Provider value={{ openLogin, closeLogin, goToLogin }}>
      {children}

      {state.open && (
        <div
          role="dialog"
          aria-modal="true"
          aria-labelledby="login-modal-title"
          onMouseDown={() => closeLogin()}
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 9999,
            background: "rgba(0,0,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            onMouseDown={(e) => e.stopPropagation()}
            style={{
              width: 440,
              background: "#fff",
              borderRadius: 8,
              padding: 18,
              boxShadow: "0 8px 32px rgba(2,6,23,0.12)",
            }}
          >
            <h3 id="login-modal-title" style={{ marginTop: 0, fontWeight: 700 }}>
              Iniciá sesión para continuar
            </h3>
            <p style={{ color: "#475569" }}>
              Para completar esta acción es necesario iniciar sesión. ¿Querés iniciar sesión ahora?
            </p>
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 16 }}>
              <button onClick={() => closeLogin()} className="px-3 py-2 rounded bg-gray-100">Cancelar</button>
              <button onClick={() => goToLogin()} className="px-4 py-2 rounded bg-emerald-600 text-white">Ir a Iniciar sesión</button>
            </div>
          </div>
        </div>
      )}
    </LoginModalContext.Provider>
  );
}

export function useLoginModal() {
  const ctx = useContext(LoginModalContext);
  if (!ctx) {
    // fallback: provide no-op functions so componentes no rompan si provider olvidado
    return {
      openLogin: (from) => {
        try { window.location && (window.location.href = `/login?from=${encodeURIComponent(getSafeAuthRedirectPath(from, "/"))}`); } catch (_) {}
      },
      closeLogin: () => {},
      goToLogin: () => { try { window.location && (window.location.href = "/login"); } catch (_) {} },
    };
  }
  return ctx;
}